import React, { useState, memo } from "react";
import { Button } from "react-bootstrap";
import EyeIcon from "../Assets/Images/EyeIcon";
import GitIcon from "../Assets/Images/GitIcon";
import ProjectDetailModal from "../Modals/ProjectDetailModal";
import { CommonService } from "../CommonSearvice";

const activeProjectTitles = new Set([
  "MIA",
  "Forever Roses",
  "Virtual Assistant",
  "Money Tracker",
  "M&M (Guard Monitor & Manage)",
  "Super MIA",
  "Quantum Datalitica",
  "InstaChat",
]);

const ProjectCard = ({ data }) => {
  const [projectModal, setProjectModal] = useState(false);

  return (
    <div className={`project-card round-border p-4 mb-4 ${data.type}`}>
      <img
        className="project-img"
        src={CommonService.ProjectImage(data.subtitle)}
        alt={data.subtitle}
        loading="lazy"
      />

      <h5 className="mt-3 d-flex align-items-center">
        {activeProjectTitles.has(data.title) && (
          <div title="Working on this" className="me-2 blinking-green"></div>
        )}
        {data.title}
      </h5>

      <p className="project-detail body-text ">
        {`${data.detail.substring(0, 140)}...`}
        <span className="cursor-pointer" onClick={() => setProjectModal(true)}>
          <b>read more</b>
        </span>
      </p>

      <div className="project-btn d-flex justify-content-between">
        {data.sourcelink !== "" && (
          <a href={data.sourcelink} target="_blank" rel="noreferrer">
            <Button variant="main-btn gray-btn">
              Source Code{" "}
              <span className="ms-2">
                <GitIcon />
              </span>
            </Button>
          </a>
        )}
        {data.livelink !== "" && (
          <a href={data.livelink} target="_blank" rel="noreferrer">
            <Button variant="main-btn shimmer-btn eye">
              Live Project{" "}
              <span className="ms-2">
                <EyeIcon />
              </span>
            </Button>
          </a>
        )}
      </div>

      {projectModal && (
        <ProjectDetailModal
          data={data}
          show={projectModal}
          onHide={() => setProjectModal(false)}
        />
      )}
    </div>
  );
};

export default memo(ProjectCard);
